import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import Footer from "@/components/Footer";
import BackToTop from "@/components/BackToTop";
import PublicHeader from "@/components/PublicHeader";
import { COMPANY } from "@/lib/company";
import { useMeta } from "@/lib/useMeta";

/** Public shell for legal pages and the FAQ — reachable without a session. */
export default function PublicPage({ title, intro, updated = true, children, testId, meta }) {
  useMeta({ title: meta?.title, description: meta?.description, path: meta?.path });
  return (
    <div className="min-h-screen flex flex-col" data-testid={testId}>
      <PublicHeader />

      <main className="flex-1 w-full max-w-[900px] mx-auto px-5 sm:px-8 py-10 sm:py-14">
        <h1 className="font-display text-3xl sm:text-4xl font-semibold leading-tight" data-testid="page-title">{title}</h1>
        {updated ? (
          <p className="text-[12px] uppercase tracking-[0.14em] text-[#F97316] mt-3" data-testid="page-effective-date">
            Effective {COMPANY.effective}
          </p>
        ) : null}
        {intro ? <p className="text-sm sm:text-base text-muted-foreground mt-5 leading-relaxed">{intro}</p> : null}
        <div className="mt-9 space-y-9">{children}</div>
      </main>

      <Footer />
      <BackToTop />
    </div>
  );
}

export const Section = ({ n, title, children }) => (
  <section data-testid={`section-${n}`}>
    <h2 className="text-base md:text-lg font-semibold">
      <span className="text-[#F97316] num mr-2">{n}.</span>
      {title}
    </h2>
    <div className="mt-3 space-y-3 text-sm text-muted-foreground leading-relaxed">{children}</div>
  </section>
);

export const Bullets = ({ items }) => (
  <ul className="space-y-2 pl-1">
    {items.map((t, i) => (
      <li key={i} className="flex gap-2.5">
        <span className="text-[#F97316] mt-0.5 shrink-0">—</span>
        <span>{t}</span>
      </li>
    ))}
  </ul>
);
